import { Box, SxProps, Theme } from "@mui/material";
import React, { ReactNode } from "react";

interface MenuIconProps {
  icon: ReactNode;
  color?: string;
  bgColor?: string;
  sx?: SxProps<Theme>;
}

export function MenuIcon({ 
  icon, 
  color = "#9c27b0", 
  bgColor = "rgba(156, 39, 176, 0.1)",
  sx = {}
}: MenuIconProps) {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        width: 40, 
        height: 40, 
        borderRadius: '50%', 
        backgroundColor: bgColor,
        mr: 1,
        ...sx
      }}
    >
      <Box sx={{ 
        color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 0
      }}>
        {icon}
      </Box>
    </Box>
  );
} 